angular.module('labApp').factory('FCSampleIdFactory', function ($resource) {
    return $resource("/api/v1.0/lab/fc-sample-ids/:slug/", {slug: '@slug'});
});